export default __webpack_public_path__ + "static/media/Captain's Legguards of the Watchtowers.86ff5be0.jpg";